<template>
  <div class="bigtop">
    <top-nav :title="smalltitle"></top-nav>
    <h1>{{ title }}</h1>
  </div>
</template>

<script>
import TopNav from './TopNav.vue'
export default {
  name: 'big-top',
  components: {
    'top-nav': TopNav
  },
  props: {
    title: {
      type:String,
      default:''
    },
    smalltitle: {
      type:String,
      // vue messes with this... &nbsp;
      default:''
    }
  }
}
</script>
<style lang="scss" scoped>
/**
 * Top bars - large titles
 */
.bigtop {
  display: flex;
  flex-direction: column;
  justify-content: center;

  background-color: #000000;
  color: #FFFFFF;
  font-family: 'adobe-garamond-pro', 'Times New Roman', serif;
  font-size: 1em;
  letter-spacing: 2px;
  text-transform: uppercase;

  padding: 10px;
}

h1 {
  font-size: 1.7em;
  margin: 2px auto 0.5em;
}
</style>
